import { useState } from 'react';

interface MissYouButtonProps {
  onClick: () => void;
  theme: any;
}

const MissYouButton = ({ onClick, theme }: MissYouButtonProps) => {
  const [isAnimating, setIsAnimating] = useState(false);

  const handleClick = () => {
    setIsAnimating(true);
    onClick();
    setTimeout(() => setIsAnimating(false), 1000);
  };

  return (
    <div className={`${theme.secondary} rounded-2xl p-8 shadow-lg`}>
      <h2 className={`text-2xl font-bold ${theme.text} mb-4 text-center`}>
        Missing You?
      </h2>
      <button
        onClick={handleClick}
        className={`
          w-full py-6 px-8 rounded-xl text-white text-2xl font-bold
          ${theme.button}
          transform transition-all duration-200
          hover:scale-105 active:scale-95
          shadow-lg hover:shadow-xl
          ${isAnimating ? 'animate-pulse' : ''}
        `}
      >
        <span className="flex items-center justify-center gap-3">
          <span className={isAnimating ? 'animate-bounce' : ''}>💕</span>
          I Miss You
          <span className={isAnimating ? 'animate-bounce' : ''}>💕</span>
        </span>
      </button>
      <p className={`text-sm ${theme.text} opacity-70 mt-4 text-center`}>
        Tap to let them know you're thinking of them
      </p>
    </div>
  );
};

export default MissYouButton;